import { ColumnListColumn } from 'components/ColumnList';

export const BASE_COLUMNS: ColumnListColumn[] = [
  { header: 'Evidence Name', accessor: 'name', align: 'left' as const },
  { header: 'User Name', accessor: 'username', align: 'left' as const },
  { header: 'Description', accessor: 'description', align: 'left' as const },
  { header: 'Uploaded Date', accessor: 'createdAt', align: 'left' as const },
  { header: 'File', accessor: 'file', align: 'left' as const }
];

export const MAX_EVIDENCE_COUNT = 5;
